import { CloseFilled } from '@/assets/icons';
import { useAuthStore } from '@/store/auth';
import { Button } from '@opaz/ui-components';
import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import FlowableTaskLayout from '../../processes/$processInstanceId/task/-components/FlowableTaskLayout';
import ProfileSelection from './ProfileSelection';

type StartServiceWizardProps = {
  onProfileConfirmed: (profileId: string) => void;
};

export default function StartServiceWizard({ onProfileConfirmed }: StartServiceWizardProps) {
  const { userProfile } = useAuthStore();
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <FlowableTaskLayout
      headerLeft={
        <Button
          className="no-underline"
          variant="ghost"
          icon={<CloseFilled />}
          onClick={() => navigate({ to: '/dashboard' })}
        >
          {t('taskDetails.exit')}
        </Button>
      }
      subHeader={<h1 className="text-foreground text-3xl font-bold">{t('profile.selection.title')}</h1>}
    >
      <ProfileSelection profiles={userProfile.profiles} onProfileConfirmed={onProfileConfirmed} />
    </FlowableTaskLayout>
  );
}
